module.exports = "img/flags/MK.1d50659.png";